import Vue from "vue";
import { $firestore } from "@/firebase";
import { Toast } from "buefy/dist/components/toast";
import _ from "lodash";
import {
  collection,
  doc,
  query,
  orderBy,
  where,
  addDoc,
  deleteDoc,
  setDoc
} from "firebase/firestore";

const getters = {
  "site/notes": state => siteId => {
    return _.get(state, `notes.observed.${siteId}`, {});
  }
};
const actions = {
  observeNotes: ({ commit, dispatch, rootGetters }, { siteId }) => {
    let notesRef = query(
      collection($firestore, `sites/${siteId}/notes`),
      orderBy(`dateCreated`, `asc`)
    );
    notesRef = rootGetters["user/isAgent"]()
      ? notesRef
      : query(notesRef, where("isRestricted", "==", false));
    return dispatch(
      "observe",
      {
        key: `sites/${siteId}/notes`,
        ref: notesRef,
        onSnapshot: snapshot => {
          _.each(snapshot.docChanges(), change => {
            const note = change.doc;
            if (change.type === "removed") {
              commit("unsetNote", {
                siteId,
                noteId: note.id
              });
            } else {
              commit("setNotes", {
                siteId: siteId,
                notes: {
                  [note.id]: _.merge({ _id: note.id }, note.data())
                }
              });
            }
          });
        }
      },
      { root: true }
    );
  },
  unobserveNotes: ({ commit, dispatch }, { siteId }) => {
    return dispatch(`unobserve`, `sites/${siteId}/notes`, { root: true }).then(
      unsubscribed => {
        if (unsubscribed) {
          commit("unsetNotes", { siteId });
        }
      }
    );
  },
  // eslint-disable-next-line no-empty-pattern
  addNote: ({}, { siteId, payload }) => {
    return new Promise((resolve, reject) => {
      const notesRef = collection($firestore, `sites/${siteId}/notes`);
      addDoc(notesRef, payload)
        .then(snapshot => {
          Toast.open({
            message: "Note added",
            position: "is-bottom",
            queue: false
          });
          resolve(snapshot);
        })
        .catch(error => {
          Toast.open({
            message: "Error adding note",
            position: "is-bottom",
            type: "is-danger",
            queue: false
          });
          reject(error);
        });
    });
  },
  // eslint-disable-next-line no-empty-pattern
  updateNote: ({}, { siteId, noteId, payload }) => {
    return new Promise((resolve, reject) => {
      const noteRef = doc($firestore, `sites/${siteId}/notes`, noteId);
      setDoc(noteRef, payload, { merge: true })
        .then(snapshot => {
          Toast.open({
            message: "Note updated",
            position: "is-bottom",
            queue: false
          });
          resolve(snapshot);
        })
        .catch(error => {
          Toast.open({
            message: "Error updating note",
            position: "is-bottom",
            type: "is-danger",
            queue: false
          });
          reject(error);
        });
    });
  },
  // eslint-disable-next-line no-empty-pattern
  deleteNote: ({}, { siteId, noteId }) => {
    return new Promise((resolve, reject) => {
      const noteRef = doc($firestore, `sites/${siteId}/notes`, noteId);
      deleteDoc(noteRef)
        .then(() => {
          Toast.open({
            message: "Note deleted",
            position: "is-bottom",
            queue: false
          });
          resolve();
        })
        .catch(error => {
          Toast.open({
            message: "Error deleting note", // "There was a problem while deleting your note!",
            position: "is-bottom",
            type: "is-danger",
            queue: false
          });
          reject(error);
        });
    });
  }
};
const mutations = {
  setNotes: (state, { siteId, notes }) => {
    Vue.set(
      state.notes.observed,
      siteId,
      _.merge({}, state.notes.observed[siteId], notes)
    );
  },
  unsetNote: (state, { siteId, noteId }) => {
    if (state.notes.observed[siteId][noteId]) {
      Vue.delete(state.notes.observed[siteId], noteId);
    }
  },
  unsetNotes: (state, { siteId }) => {
    if (state.notes.observed[siteId]) {
      Vue.delete(state.notes.observed, siteId);
    }
  }
};

export { getters, actions, mutations };
